import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../../i18n';

// Bandeau sombre final d'appel à l'action.
const CtaBand: React.FC = () => {
  const t = useT();
  return (
    <section className="mk-cta-wrap mk-container">
      <div className="mk-cta">
        <h2 className="mk-h2">
          {t('Votre mariage mérite mieux')} <em>{t('qu’un tableur')}</em>.
        </h2>
        <Link to="/signup" className="mkt-btn mk-btn-lg mk-btn-light">
          {t('Commencer gratuitement')}
        </Link>
      </div>
    </section>
  );
};

export default CtaBand;
